import { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { HeaderPage } from "../../components/HeaderPage"
import MetricsChart from "../../components/MetricsChart"
import { DiagnosesNoAnswerList } from "../../components/OscMetrics/DiagnosesNoAnswerList"
import { DiagnosisList } from "../../components/ResultDiagnosis/DiagnosisList"
import OscContext from "../../context/Osc"
import useApi from "../../hooks/useApi"
import { OscLoggedLayout } from "../../layout/OscLoggedLayout"
import { Diagnosis } from "../../types/Diagnosis"

const Metrics = () => {

    const api = useApi();
    const { state: user } = useContext(OscContext)

    const [diagnosis, setDiagnosis] = useState<Diagnosis[]>([]);
    const [diagnosisNo, setDiagnosisNo] = useState<Diagnosis[]>([]);
    const [diagnosisAll, setDiagnosisAll] = useState<Diagnosis[]>([]);


    const loadData = useCallback(async () => {
        await api.get("/client/diagnoses/all").then(res => {
            setDiagnosisAll(res.data)
        }).catch(console.log)
        await api.get("/client/diagnoses/", { params: { answer: true } }).then(res => {
            setDiagnosis(res.data)
        }).catch(console.log)
        await api.get("/client/diagnoses/", { params: { answer: false } }).then(res => {
            setDiagnosisNo(res.data)
        }).catch(console.log)
    }, [api])

    const color = useMemo(():{color:string, backGround:string}=>{
        if(!user?.average) return {color:"", backGround:""}
        if(user.average < 4)
            return {color:"red-500", backGround:"bg-red-100"}
        if(user.average < 7)
            return {color:"yellow-500", backGround:"bg-red-100"}
        if(user.average > 6)
            return {color:"green-500", backGround:"bg-green-100"}
        return {color:"gray-500", backGround:"bg-gray-100"}
    },[user])

    useEffect(() => {
        loadData()
    }, [loadData])
    return (
        <OscLoggedLayout>
            <div className="grid grid-cols-5">
                <div className="col-span-3">
                    <HeaderPage name="Métricas" />
                    <div className="flex flex-col w-5/12">
                        <div className="flex justify-between items-end mb-1">
                            <div className="font-bold text-lg">Nota Geral</div>
                            <div className={`text-2xl font-extrabold text-${color.color}`}>
                                    {user?.average?.toFixed(1)}
                            </div>
                        </div>
                        <div className={`w-full rounded-md ${color.backGround}`}>
                            <div className={`h-10 rounded-l-md bg-${color.color}`} style={{ width: `${user?.average ? user.average * 10 : 0}%` }}>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="col-span-2">
                <MetricsChart diagnosis={diagnosisAll} />
                </div>
            </div>


            <div className="grid grid-cols-12 text-gray-500 text-lg py-2">
                <div className="col-span-1">Nota</div>
                <div className="col-span-4">Teste</div>
                <div className="col-span-4">Progresso</div>
                <div className="col-span-2 text-center">Média</div>
                <div className="col-span-1"></div>
            </div>
            {diagnosis?.map(item => (
                <div key={item.id} className="grid grid-cols-12 bg-white p-2">
                    <DiagnosisList diagnosis={item} />
                </div>
            ))}
            {diagnosisNo?.map(item => (
                <div key={item.id} className="grid grid-cols-12 bg-white p-2">
                    <DiagnosesNoAnswerList diagnosis={item} />
                </div>
            ))}


        </OscLoggedLayout>
    )
}


export default Metrics
